export default __webpack_public_path__ + "media/images/features/local_delivery/table_frame_sp-0cc91b49480ff6f4bb5d79bb3973a304.png";